import { render, staticRenderFns } from "./MilestoneCreateConfirm.vue?vue&type=template&id=ade0c31a&scoped=true&"
import script from "./MilestoneCreateConfirm.vue?vue&type=script&lang=js&"
export * from "./MilestoneCreateConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneCreateConfirm.vue?vue&type=style&index=0&id=ade0c31a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade0c31a",
  null
  
)

export default component.exports